import type {
  SortDirection as DomainSortDirection,
  SortDirectionLike as DomainSortDirectionLike
} from '../../../domain/sort-direction.domain';

// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace SortDirection {
  export const ASC = 'asc' as const;
  export const DESC = 'desc' as const;
}
export type SortDirection = DomainSortDirection;
export type SortDirectionLike = DomainSortDirectionLike;

